import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/components/pages/Home'
import Offer from '@/components/pages/Offer'
// import Customers from '@/components/pages/Customers';
import Company from '@/components/pages/Company'
import Blog from '@/components/pages/Blog'

Vue.use(VueRouter)
Vue.use(Meta)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/offer',
      name: 'Offer',
      component: Offer
    },
    // {
    //   path: '/customers',
    //   name: 'Customers',
    //   component: Customers
    // },
    {
      path: '/company',
      name: 'Company',
      component: Company
    },
    {
      path: '/blog*',
      name: 'Blog',
      component: Blog
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  window.prerenderReady = false
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js